export enum NotificationTypeEnum {
  NewCaseCreated = 1,
  UserInactivityAlert = 2,
  DataCollectionReminder = 3,
  SubscriptionExpiryReminder = 4,
  CaseFeedbackAlert = 5,
  BroadcastGeneralNotification = 6,
  DownloadReportReady = 7,
  DownloadReportFailed = 8,
  CaseClosure = 9,
  AddNewBehavior = 10,
  ActiveInactiveBehavior = 11,
  FeedbackNotSubmitted = 12,
  FeedbackScoreBelowThreshold = 13,
  FidelityChangeRequested = 14,
  FidelityChangeReceived = 15,
}
